import Input from '../../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../../Core/Fields/Floating/Checkbox';
import SelectSearchApi from '../../../../../Core/Fields/Floating/SelectSearchApi';

const DiscountSection = ({ error, fulldata, onFieldChange, totalPriceWithTax, totalamount, discountAmountData }) => {

  const discountOn = fulldata.generalDetails.discountOn;
  const baseAmount = discountOn === "Grand Total" ? parseFloat(totalamount || 0) : parseFloat(totalPriceWithTax || 0);

  const handlePercentageChange = (value) => {
    const percentage = parseFloat(value) || 0;
    const discountAmount = (((discountOn ? baseAmount : 0) * percentage) / 100).toFixed(2);

    onFieldChange("discountValue", percentage);
    setTimeout(() => {
      onFieldChange("discountAmount", discountAmount);
    }, 250);
  };

  const handleAmountChange = (value) => {
    const amount = parseFloat(value) || 0;
    const discountPercentage = ((amount / (discountOn ? baseAmount : 0)) * 100).toFixed(2);

    onFieldChange("discountAmount", amount);
    setTimeout(() => {
      onFieldChange("discountValue", discountPercentage);
    }, 250);
  };

  const changeValue = async (type,e) =>{
    if(!fulldata.generalDetails.customer){
          error.seterrorMessage(`Please select a customer before applying discount.`);
          error.seterrorType("Error");
          error.setisErrorVisible(true);
          return;
    }{
        if(type == "discountpercentage"){
           handlePercentageChange(e.target.value);
        }
        if(type == "discountamount"){
            handleAmountChange(e.target.value);
        }
    }
  }

  return (
    <div
      className=''
      style={{
        backgroundColor: '#EBE6FA',
        height: "100%",
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '10px',
      }}
    >
      <div style={{ display: 'flex', gap: '15px' }}>
        <div style={{ flex: 1 }}>
          <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>
            Additional Discount
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '15px' }}>
        <div style={{ flex: 1 }}>
          <SelectSearchApi
            label="Apply Additional Discount On"
            list={[{ value: "Grand Total" }, { value: "Net Total" }]}
            style={{ height: "30px" }}
            value={discountOn}
            getOptionLabel={(item) => item.value}
            getOptionValue={(item) => item.value}
            onChange={(e) => {onFieldChange('discountOn', e);setTimeout(() => {changeValue('discountpercentage',{target:{value:0}})}, 200);}}
          />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ height: '19px' }}></label>
          <Checkbox
            id="IsSubcontracted"
            label="Is Cash or Non Trade Discount"
            value={fulldata.generalDetails.discountBool}
            onChange={(e) => onFieldChange('discountBool', !fulldata.generalDetails.discountBool)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: '15px' }}>
        <div style={{ flex: 1 }}>
          <Input
            label="Additional Discount Percentage"
            type="number"
            style={{ height: "30px" }}
            value={fulldata.generalDetails.discountValue || ""}
            onChange={(e) => {changeValue('discountpercentage',e)}}
          />
        </div>
        <div style={{ flex: 1 }}>
          <Input
            label="Additional Discount Amount (INR)"
            type="number"
            style={{ height: "30px" }}
            value={fulldata.generalDetails.discountAmount || ""}
            onChange={(e) => {changeValue('discountamount',e)}}
          />
        </div>
      </div>

    </div>
  );
};

export default DiscountSection;
